import gql from 'graphql-tag';
import { clients } from '../../util/clients';
import { fieldsToGqlString } from '../../util/shared/vue-global';

const { backend } = clients.direct;

const defaultDropdownlistFields = {
  _id: '',
  Name: '',
  DataDefinition: {
    ShortName: '',
    LongName: '',
    Removed: '',
  },
};

export const ListsActions = {
  async loadLists({ commit, dispatch }, { criteria, fields }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      const gqlfields = fields || defaultDropdownlistFields;

      results = await backend.query({
        query: gql`query dropdownlists($criteria: dropdownlistsCriteriaType) {
          dropdownlists(criteria: $criteria) {
            ${fieldsToGqlString(gqlfields)}
          }
        }`,
        variables: { criteria },
        fetchPolicy: 'no-cache',
      });

      clients.handleGQLErrors(results, commit);
      const { dropdownlists } = results.data;
      return dropdownlists || [];
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem loading dropdown lists.', { root: true });
      return [];
    }
  },

  async upsertList({ commit, dispatch }, { item, fields }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      const gqlfields = fields || defaultDropdownlistFields;

      results = await backend.mutate({
        mutation: gql`mutation upsertDropdownlist($item: dropdownlistsInputType) {
          upsertDropdownlist(upsert: $item) {
            ${fieldsToGqlString(gqlfields)}
          }
        }`,
        variables: { item },
      });

      clients.handleGQLErrors(results, commit);
      const { upsertDropdownlist } = results.data;
      return upsertDropdownlist;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem saving the dropdown list.', { root: true });
      return null;
    }
  },

  async deleteList({ commit, dispatch }, { _id }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });

      results = await backend.mutate({
        mutation: gql`mutation deleteDropdownlist($_id: ID!) {
          deleteDropdownlist(_id: $_id) {
            _id
          }
        }`,
        variables: { _id },
      });

      clients.handleGQLErrors(results, commit);
      const { deleteDropdownlist } = results.data;
      return deleteDropdownlist;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem deleting the dropdown list.', { root: true });
      return null;
    }
  },

  async loadListByName({ commit, dispatch }, { name, fields }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      const gqlfields = fields || defaultDropdownlistFields;

      results = await backend.query({
        query: gql`query dropdownlists($criteria: dropdownlistsCriteriaType) {
          dropdownlists(criteria: $criteria) {
            ${fieldsToGqlString(gqlfields)}
          }
        }`,
        variables: { criteria: { Name: name } },
        fetchPolicy: 'no-cache',
      });

      clients.handleGQLErrors(results, commit);
      const { dropdownlists } = results.data;
      return dropdownlists && dropdownlists.length > 0 ? dropdownlists[0] : null;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem loading the dropdown list.', { root: true });
      return null;
    }
  },
};

export default ListsActions;
